import { atom } from 'jotai';
import type { FreePhoto_Base } from '~/common/typescript/models/FreePhoto';

/**
 * Filter interface for FreePhoto list
 */
export interface FreePhotoFilters {
  projectId?: number;
  dateRange?: [string, string];
  locationQuery?: string;
  sortBy: 'date_desc' | 'date_asc' | 'name_asc' | 'name_desc';
}

/**
 * Atom for storing the list of free photos
 */
export const freePhotoListAtom = atom<FreePhoto_Base[]>([]);

/**
 * Atom for storing the currently selected photo (for detail modal)
 */
export const selectedFreePhotoAtom = atom<FreePhoto_Base | null>(null);

/**
 * Atom for storing filter state
 */
export const freePhotoFiltersAtom = atom<FreePhotoFilters>({
  sortBy: 'date_desc',
});

/**
 * Atom for view mode (grid, list, or map)
 */
export const freePhotoViewModeAtom = atom<'grid' | 'list' | 'map'>('grid');

/**
 * Atom for total count of photos (for pagination)
 */
export const freePhotoTotalCountAtom = atom<number>(0);

/**
 * Atom for current page number
 */
export const freePhotoPageAtom = atom<number>(1);

/**
 * Atom for page size
 */
export const freePhotoPageSizeAtom = atom<number>(20);

/**
 * Atom for loading state
 */
export const freePhotoLoadingAtom = atom<boolean>(false);